/* src/app/shared/components/form-controls/ag-tooltip/ag-tooltip.component.scss */
.tooltip-container {
  padding: 12px;
  background-color: #d7263c;
  border-radius: 5px;
  box-shadow: 6px 6px 14px rgba(0, 0, 0, 0.3);
  color: #ffffff;
  z-index: 1000;
  min-width: 80px;
  text-align: center;
  font-size: 12px;
}
.tooltip-container .arrow,
.tooltip-container .arrow-bottom {
  position: absolute;
  left: calc(50% - 8px);
  z-index: 1002 !important;
}
.tooltip-container .arrow-bottom {
  height: 16px;
  width: 16px;
  transform: rotate(45deg);
  border-radius: 0 0 4px 0;
  background:
    linear-gradient(
      to bottom right,
      transparent 50%,
      transparent 50%,
      #d7263c 50%,
      #d7263c 100%);
}
/*# sourceMappingURL=ag-tooltip.component.css.map */
